/** The 409 `code` for an answer to a question the current answers hide. */
export const QUESTION_HIDDEN = 'QUESTION_HIDDEN';
//# sourceMappingURL=response-recording.js.map